import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  assignments: [],
  submissions: [],
  currentAssignment: null,
  currentSubmission: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0
  },
  filters: {
    search: '',
    status: 'all',
    dueDate: null
  }
}

const homeworkSlice = createSlice({
  name: 'homework',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setError: (state, action) => {
      state.error = action.payload
    },
    setAssignments: (state, action) => {
      state.assignments = action.payload
    },
    setSubmissions: (state, action) => {
      state.submissions = action.payload
    },
    setCurrentAssignment: (state, action) => {
      state.currentAssignment = action.payload
    },
    setCurrentSubmission: (state, action) => {
      state.currentSubmission = action.payload
    },
    addAssignment: (state, action) => {
      state.assignments.push(action.payload)
    },
    updateAssignment: (state, action) => {
      const index = state.assignments.findIndex(assignment => assignment.id === action.payload.id)
      if (index !== -1) {
        state.assignments[index] = action.payload
      }
    },
    removeAssignment: (state, action) => {
      state.assignments = state.assignments.filter(assignment => assignment.id !== action.payload)
    },
    addSubmission: (state, action) => {
      state.submissions.push(action.payload)
    },
    updateSubmission: (state, action) => {
      const index = state.submissions.findIndex(submission => submission.id === action.payload.id)
      if (index !== -1) {
        state.submissions[index] = action.payload
      }
    },
    setPagination: (state, action) => {
      state.pagination = { ...state.pagination, ...action.payload }
    },
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload }
    },
    clearError: (state) => {
      state.error = null
    }
  }
})

export const {
  setLoading,
  setError,
  setAssignments,
  setSubmissions,
  setCurrentAssignment,
  setCurrentSubmission,
  addAssignment,
  updateAssignment,
  removeAssignment,
  addSubmission,
  updateSubmission,
  setPagination,
  setFilters,
  clearError
} = homeworkSlice.actions

export default homeworkSlice.reducer